import styled, { css } from "styled-components";

interface StyledListMoreMenuProps {
  $left: number;
  $top: number;
  $height: number;
}

export const StyledListMoreMenu = styled.div<StyledListMoreMenuProps>`
  .more-menu-btn {
    position: fixed;
    left: ${(props) => props.$left}px;
    top: ${(props) => props.$top}px;
    background-color: blue;
    border: 0.1rem solid var(--pri-blue-4);
    border-radius: 0.4rem;
    background: var(--bg-gray-normal);
    &.reverse {
      top: ${(props) =>
        props.$height ? props.$top - props.$height : props.$top}px;
    }
    & > div {
      border-radius: 0;
      &:not(:last-child) {
        border-bottom: 0.1rem solid var(--pri-blue-4);
      }
      &:first-child {
        border-top-left-radius: 0.4rem;
        border-top-right-radius: 0.4rem;
      }
      &:last-child {
        border-bottom-left-radius: 0.4rem;
        border-bottom-right-radius: 0.4rem;
      }
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
